import React from "react";
import nextId from "react-id-generator";
import {
  editEmployment,
  updateCandidateEmployment,
} from "../../../APIs/PostAPIS";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import "./add-employement.style.scss";
export default function AddEmployement({
  num = 0,
  closeIt,
  initialChecking,
  userDetails,
  setNotification,
  notification,
  editData,
  edit,
}) {
  const [loading, setLoading] = React.useState(false);
  const [data, handleChanges] = React.useState({
    institute_name: "",
    curriculum: "",
    designation: "",
    class: "",
    worked_from: { month: "", year: "" },
    worked_till: { month: "", year: "" },
    currently_working: true,
    stillWorking: true,
  });
  const handleChange = (e) => {
    let temp = {
      ...data,
      currently_working: e.target.checked,
    };
    handleChanges({ ...temp });
  };
  const handleUpdate = async () => {
    setLoading(true);
    let temp = {
      candidate_fresher: false,
      candidate_employment: !userDetails.candidate_employment
        ? [data]
        : [...userDetails.candidate_employment, data],
      candidate_total_experience: userDetails.candidate_total_experience,
      candidate_skill: userDetails.candidate_skill,
    };
    try {
      let res = await updateCandidateEmployment({ ...temp });
      if (!res.data.error) {
        setNotification({
          status: true,
          title: res.data.message,
          moreDetails: ``,
        });
        initialChecking();
        closeIt();
      } else {
      }
    } catch (error) {
      setLoading(false);
      setNotification({
        status: true,
        title: "Something went wrong",
        moreDetails: ``,
      });
      closeIt();
    }
    let a = setTimeout(() => {
      setNotification({
        status: false,
        title: "",
        moreDetails: ``,
      });
      clearTimeout(a);
    }, 3000);
  };
  const handleEdit = async () => {
    setLoading(true);
    let temp = {
      candidate_fresher: userDetails.candidate_fresher ? true : false,
      candidate_employment: !userDetails.candidate_employment
        ? [data]
        : [...userDetails.candidate_employment, data],
      candidate_total_experience: userDetails.candidate_total_experience,
      candidate_skill: userDetails.candidate_skill,
    };
    try {
      let res = await editEmployment(userDetails._id, data._id, data);
      if (res.data.statusCode === 200) {
        setNotification({
          status: true,
          title: res.data.message,
          moreDetails: ``,
        });
        initialChecking();
        closeIt();
      } else {
      }
    } catch (error) {
      console.error(error)
      setLoading(false);
      setNotification({
        status: true,
        title: "Something went wrong",
        moreDetails: ``,
      });
      closeIt();
    }
    let a = setTimeout(() => {
      setNotification({
        status: false,
        title: "",
        moreDetails: ``,
      });
      clearTimeout(a);
    }, 3000);
  };
  React.useEffect(() => {
    if (!edit) return;
    handleChanges({ ...editData });
  }, [editData]);
  return (
    <div className="add-employment-wrapper">
      <div className="employment-form">
        <button onClick={() => closeIt()} className="close-button">
          X
        </button>
        <div className="fancy-input">
          <span>Institute Name*</span>
          <input
            value={data.institute_name}
            placeholder="Goa University"
            onChange={(e) =>
              handleChanges({ ...data, institute_name: e.target.value }, num)
            }
          />
        </div>

        <CustomDropdown
          list={curriculumList}
          title="Curriculum*"
          message="Select"
          selected={data.curriculum}
          sendClicked={(obj) =>
            handleChanges({ ...data, curriculum: obj.id }, num)
          }
        />

        <CustomDropdown
          list={designationList}
          title="Designation*"
          message="Select"
          selected={data.designation}
          sendClicked={(obj) =>
            handleChanges({ ...data, designation: obj.id }, num)
          }
        />

        <CustomDropdown
          sendClicked={(obj) => handleChanges({ ...data, class: obj.id }, num)}
          list={classes}
          title="Class*"
          message="Select"
          selected={data.class}
        />
        <div className="worked-range">
          <h6>Worked From*</h6>
          <div className="worked-range-wrapper">
            <div className="range-wrapper">
              <CustomDropdown
                selected={data.worked_from.month}
                sendClicked={(obj) =>
                  handleChanges(
                    {
                      ...data,
                      worked_from: { ...data.worked_from, month: obj.id },
                    },
                    num
                  )
                }
                list={months}
                title=""
                message="Select Month"
              />
            </div>
            <div className="range-wrapper">
              <CustomDropdown
                selected={data.worked_from.year}
                sendClicked={(obj) =>
                  handleChanges(
                    {
                      ...data,
                      worked_from: { ...data.worked_from, year: obj.id },
                    },
                    num
                  )
                }
                list={years}
                title=""
                message="Select Year"
              />
            </div>
          </div>
        </div>
        <div className="current-check">
          <label>
            <input
              onChange={(e) => handleChange(e)}
              checked={data.currently_working}
              type="checkbox"
            />
            I'm currently Working in this role
          </label>
        </div>
        {!data.currently_working && (
          <div className="worked-range">
            <h6>Worked Until*</h6>
            <div className="worked-range-wrapper">
              <div className="range-wrapper">
                <CustomDropdown
                  sendClicked={(obj) =>
                    handleChanges(
                      {
                        ...data,
                        worked_till: { ...data.worked_till, month: obj.id },
                      },
                      num
                    )
                  }
                  selected={data.worked_till.month}
                  list={months}
                  title=""
                  message="Select Month"
                />
              </div>
              <div className="range-wrapper">
                <CustomDropdown
                  sendClicked={(obj) =>
                    handleChanges(
                      {
                        ...data,
                        worked_till: { ...data.worked_till, year: obj.name },
                      },
                      num
                    )
                  }
                  selected={data.worked_till.year}
                  list={years}
                  title=""
                  message="Select Year"
                />
              </div>
            </div>
          </div>
        )}

        <div className="add-new">
          {edit ? (
            <button onClick={() => handleEdit()}>
              {loading ? "Editing..." : "Edit Employment"}
            </button>
          ) : (
            <button onClick={() => handleUpdate()}>
              {loading ? "Adding..." : "Add Employment"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

const curriculumList = [
  { _id: nextId(), name: "CBSE", id: "cbse" },
  { _id: nextId(), name: "NCERT", id: "ncert" },
  { _id: nextId(), name: "IGCSE", id: "IGCSE" },
  { _id: nextId(), name: "PU", id: "PU" },
  { _id: nextId(), name: "IB", id: "IB" },
  { _id: nextId(), name: "Higher Education", id: "Higher Education" },
];
const designationList = [
  { _id: nextId(), name: "Teacher", id: "teacher" },
  { _id: nextId(), name: "Headmaster", id: "head" },
  { _id: nextId(), name: "Principal", id: "pricipal" },
];

const classes = [
  { _id: nextId(), name: "Class 1 - 4", id: "1_4" },
  { _id: nextId(), name: "Class 5 - 8", id: "5_8" },
  { _id: nextId(), name: "Class 8 - 10", id: "8_10" },
];
const months = [
  { _id: nextId(), name: "January", id: "jan" },
  { _id: nextId(), name: "February", id: "feb" },
  { _id: nextId(), name: "March", id: "march" },
  { _id: nextId(), name: "April", id: "april" },
  { _id: nextId(), name: "May", id: "may" },
  { _id: nextId(), name: "June", id: "june" },
  { _id: nextId(), name: "July", id: "july" },
  { _id: nextId(), name: "August", id: "aug" },
  { _id: nextId(), name: "September", id: "sept" },
  { _id: nextId(), name: "October", id: "oct" },
  { _id: nextId(), name: "November", id: "nov" },
  { _id: nextId(), name: "December", id: "dec" },
];

const years = [
  { _id: nextId(), name: "2020", id: "2020" },
  { _id: nextId(), name: "2019", id: "2019" },
  { _id: nextId(), name: "2018", id: "2018" },
  { _id: nextId(), name: "2017", id: "2017" },
  { _id: nextId(), name: "2016", id: "2016" },
  { _id: nextId(), name: "2015", id: "2015" },
  { _id: nextId(), name: "2014", id: "2014" },
  { _id: nextId(), name: "2013", id: "2013" },
  { _id: nextId(), name: "2012", id: "2012" },
  { _id: nextId(), name: "2011", id: "2011" },
  { _id: nextId(), name: "2010", id: "2010" },
  { _id: nextId(), name: "2009", id: "2009" },
  { _id: nextId(), name: "2008", id: "2008" },
  { _id: nextId(), name: "2007", id: "2007" },
  { _id: nextId(), name: "2006", id: "2006" },
  { _id: nextId(), name: "2005", id: "2005" },
  { _id: nextId(), name: "2004", id: "2004" },
  { _id: nextId(), name: "2003", id: "2003" },
  { _id: nextId(), name: "2002", id: "2002" },
  { _id: nextId(), name: "2001", id: "2001" },
  { _id: nextId(), name: "2000", id: "2000" },
  { _id: nextId(), name: "1999", id: "1999" },
  { _id: nextId(), name: "1998", id: "1998" },
  { _id: nextId(), name: "1997", id: "1997" },
  { _id: nextId(), name: "1996", id: "1996" },
  { _id: nextId(), name: "1995", id: "1995" },
  { _id: nextId(), name: "1994", id: "1994" },
  { _id: nextId(), name: "1993", id: "1993" },
  { _id: nextId(), name: "1992", id: "1992" },
  { _id: nextId(), name: "1991", id: "1991" },
  { _id: nextId(), name: "1990", id: "1990" },
];
